import React, { useState, useEffect, useCallback } from 'react'
import Cookies from 'js-cookie'
import config from '../../../config'
import { Modal, Table } from 'react-bootstrap'
import { getDateDDMMYYYY } from '../utils'

const LIMIT_PAGE = 10

const BannedUserLogs = ({ user, isDisplayBannedUserLogs, setIsDisplayBannedUserLogs }) => {
  const [logs, setLogs] = useState([])
  const [pagination, setPagination] = useState({ page: 1, hasNext: false })

  const fetchLogs = useCallback(async (userId, page) => {
    try {

      const resLogs = await fetch(`${config.apiAdminGateway}/api/v1/logs?userId=${userId}&page=${page}&limit=${LIMIT_PAGE}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const toJson = await resLogs.json()
      const { data, pagination, status: { code, description } } = toJson

      if (code !== 0) {
        throw new Error(description)
      }

      const newLogs = data.map((log) => {
        const expiredAt = log.details.expiredAt ? getDateDDMMYYYY(log.details.expiredAt) : '' // sometime expiredAt is null 
        const timestamp = `${getDateDDMMYYYY(log.timestamp)} : ${new Date(log.timestamp).toLocaleTimeString('th-TH')} น.`

        return {
          expiredAt,
          timestamp,
          id: log.id,
          reason: log.details.reason,
          admin: log.admin.username,
        }
      })

      setLogs(newLogs)
      setPagination({ page, hasNext: pagination.hasNext })

    } catch (error) {
      console.error('Error while trying to fetch orders.', error)
    }
  }, [])

  useEffect(() => {
    fetchLogs(user.id, pagination.page)
  }, [user.id, pagination.page, fetchLogs])

  return (
    <Modal className="fade" size="xl" show={isDisplayBannedUserLogs}>
      <Modal.Header>
        <Modal.Title>ประวัติการแบน {user.userId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>เหตุผลที่ถูกแบน</th>
              <th>สิ้นสุดการแบน</th>
              <th>ผู้ดูแลที่แบน</th>
              <th>แบนเมื่อวันที่</th>
            </tr>
          </thead>
          <tbody>
            {
              logs.map((log, index) => (
                <tr key={log.id}>
                  <td>{index + 1}</td>
                  <td>{log.reason}</td>
                  <td>{log.expiredAt}</td>
                  <td>{log.admin}</td>
                  <td>{log.timestamp}</td>
                </tr>
              ))
            }
          </tbody>
        </Table>
        <div style={{ textAlign: 'right', marginTop: 15 }}>
          {pagination.page > 1 && (
            <button
              className="btn btn-primary light"
              onClick={() => setPagination((pagination) => ({ ...pagination, page: pagination.page - 1 }))}
            >
              {'<'} หน้าก่อนหน้า
            </button>
          )}{' '}
          <button className="btn btn-primary light">{pagination.page}</button>{' '}
          {pagination.hasNext && (
            <button
              className="btn btn-primary light"
              onClick={() => setPagination((pagination) => ({ ...pagination, page: pagination.page + 1 }))}
            >
              หน้าถัดไป {'>'}
            </button>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm" onClick={() => setIsDisplayBannedUserLogs(false)}>ปิด</button>
      </Modal.Footer>
    </Modal>
  )
}

export default BannedUserLogs
